module.exports = __webpack_public_path__ + "static/media/exam-time.bf1124e8.svg";